export class adminUserFilter{
  firstName:any;
  lastName:any;
  mobileNumber:any;
  emailId:any;
  roleId:number;
  passWord:any;
  profilePhoto:any;
  id:any
  _id:any;
  status:any

}